import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Spinner } from "reactstrap";
import { Link } from "react-router-dom";

import avatar1 from "../../assets/images/users/avatar-1.jpg";
import profileImg from "../../assets/images/logo.jpeg";

const WelcomeComp = () => {
  const [userData, setUserData] = useState({
    name: "Kullanıcı",
    tasksCount: 0,
    totalRevenue: 0,
    isLoading: true,
    roleTitle: "İş Ortağı"
  });

  useEffect(() => {
    const fetchUserStats = async () => {
      try {
        const authUser = JSON.parse(localStorage.getItem("authUser"));
        const userId = authUser?.ID;
        const userName = authUser?.Users_NameSurname || "Kullanıcı";
        
        // DİKKAT: Artık Admin kontrolü ID 3 üzerinden yapılıyor
        const isAdmin = authUser?.Users_Type_ID === 3; 

        if (!userId) {
          setUserData(prev => ({ ...prev, isLoading: false }));
          return;
        }

        // --- 1. GÖREV SAYISI ÇEKME ---
        // Admin ise tüm tamamlanan görevler, sürücü ise sadece kendi tamamladıkları
        const taskFilter = isAdmin 
          ? "Advert_DeliveryStatus_Status eq 'Tamamlandı'" 
          : `Advert_DeliveryStatus_Status eq 'Tamamlandı' and Users_ID eq ${userId}`;
        
        const resTasks = await fetch(`https://hiflowapi.stechomeyazilim.info/Advert_DeliveryStatus?$filter=${taskFilter}`);
        const dataTasks = await resTasks.json();
        const completedCount = dataTasks.value ? dataTasks.value.length : 0;

        // --- 2. KAZANÇ / CİRO ÇEKME ---
        // Admin ise tüm ilanların toplamı, sürücü ise sadece kendi ilanlarının toplamı
        const advertFilter = isAdmin ? "" : `$filter=Users_ID eq ${userId}`;
        const resAdverts = await fetch(`https://hiflowapi.stechomeyazilim.info/Advert?${advertFilter}`);
        const dataAdverts = await resAdverts.json();
        
        const totalRevenue = dataAdverts.value 
          ? dataAdverts.value.reduce((acc, curr) => acc + (curr.Price || 0), 0) 
          : 0;

        setUserData({
          name: userName,
          tasksCount: completedCount,
          totalRevenue: totalRevenue,
          isLoading: false,
          roleTitle: isAdmin ? "Sistem Yöneticisi" : "Taşıyıcı İş Ortağı"
        });

      } catch (error) {
        console.error("Özet veriler çekilirken hata:", error);
        setUserData(prev => ({ ...prev, isLoading: false }));
      }
    };

    fetchUserStats();
  }, []);

  // Admin olup olmadığını tekrar kontrol ediyoruz (Render için)
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const isAdmin = authUser?.Users_Type_ID === 3;

  return (
    <React.Fragment>
      <Card className="overflow-hidden">
        <div className="bg-primary-subtle">
          <Row>
            <Col xs="7">
              <div className="text-primary p-3">
                <h5 className="text-primary">Tekrar Hoş Geldiniz !</h5>
                <p>{isAdmin ? "Yönetim Paneli Özeti" : "Partner Expedicar Paneli"}</p>
              </div>
            </Col>
            <Col xs="5" className="align-self-end">
              <img src={profileImg} alt="" className="img-fluid" />
            </Col>
          </Row>
        </div>
        <CardBody className="pt-0">
          <Row>
            <Col sm="4">
              <div className="avatar-md profile-user-wid mb-4">
                <img
                  src={avatar1}
                  alt="Profil"
                  className="img-thumbnail "
                />
              </div>
              <h5 className="font-size-15 text-truncate">{userData.name}</h5>
              <p className="text-muted mb-0 text-truncate">{userData.roleTitle}</p>
            </Col>

            <Col sm="8">
              <div className="pt-4">
                <Row>
                  <Col xs="6">
                    <h5 className="font-size-15">
                      {userData.isLoading ? <Spinner size="sm" color="primary" /> : userData.tasksCount}
                    </h5>
                    <p className="text-muted mb-0">{isAdmin ? "Toplam Görev" : "Görevlerim"}</p>
                  </Col>
                  <Col xs="6">
                    <h5 className="font-size-15">
                      {userData.isLoading ? <Spinner size="sm" color="primary" /> : `${userData.totalRevenue.toLocaleString("tr-TR")} TL`}
                    </h5>
                    <p className="text-muted mb-0">{isAdmin ? "Toplam Ciro" : "Toplam Kazanç"}</p>
                  </Col>
                </Row>
                <div className="mt-4">
                  <Link
                    to={isAdmin ? "/contacts-list" : "/hesabim"}
                    className="btn btn-primary btn-sm"
                  >
                    {isAdmin ? "Kullanıcıları Yönet" : "Profili Görüntüle"} <i className="mdi mdi-arrow-right ms-1"></i>
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default WelcomeComp;